import {translate} from 'views/module';

import caregiverStatus from '../../../../lang/en/caregiver/Status';
import clientStatus from '../../../../lang/en/client/Status';

const getAutomationRules = () => {
  return [
    {
      resourceType: 'CLIENT_DETAILS',
      resourceTypeLabel: translate('automations.Automations.TriggerConditions.Resources.Client'),
      sentenceConnector: translate('automations.Automations.New.Steps.Rules.TriggerConditions.PropertyInfix'),
      fields: [
        {
          key: 'status',
          label: translate('automations.Automations.TriggerConditions.Fields.Status'),
          ruleType: 'STRING_EQUAL',
          isRequired: true,
          isVisibleToAdmin: true,
          options: Object.keys(clientStatus).map((value) => ({
            value,
            label: translate(`client.Status.${value}.Title`),
          })),
        },
      ],
    },
    {
      resourceType: 'CAREGIVER_DETAILS',
      resourceTypeLabel: translate('automations.Automations.TriggerConditions.Resources.Caregiver'),
      sentenceConnector: translate('automations.Automations.New.Steps.Rules.TriggerConditions.PropertyInfix'),
      fields: [
        {
          key: 'status',
          label: translate('automations.Automations.TriggerConditions.Fields.Status'),
          ruleType: 'STRING_EQUAL',
          isRequired: true,
          isVisibleToAdmin: true,
          options: Object.keys(caregiverStatus).map((value) => ({
            value,
            label: translate(`caregiver.Status.${value}.Title`),
          })),
        },
      ],
    },
    {
      resourceType: 'EVENT_CAREGIVER_UPDATES',
      resourceTypeLabel: translate('automations.Automations.TriggerConditions.Resources.EventCaregiverUpdate'),
      sentenceConnector: translate('automations.Automations.New.Steps.Rules.TriggerConditions.EventInfix'),
      fields: [
        {
          key: 'type',
          label: translate('automations.Automations.TriggerConditions.Fields.EventType'),
          ruleType: 'STRING_EQUAL',
          isRequired: true,
          isVisibleToAdmin: true,
          options: [
            {
              value: 'shiftConfirmation',
              label: translate('automations.Automations.TriggerConditions.EventTypes.ShiftConfirmation'),
            },
            {
              value: 'clockInConfirmation',
              label: translate('automations.Automations.TriggerConditions.EventTypes.ClockInConfirmation'),
            },
            {
              value: 'clockOutConfirmation',
              label: translate('automations.Automations.TriggerConditions.EventTypes.ClockOutConfirmation'),
            },
            {
              value: 'requestCancel',
              label: translate('automations.Automations.TriggerConditions.EventTypes.RequestCancel'),
            },
            {
              value: 'requestReschedule',
              label: translate('automations.Automations.TriggerConditions.EventTypes.RequestReschedule'),
            },
            {
              value: 'shiftConfirmationMissed',
              label: translate('automations.Automations.TriggerConditions.EventTypes.ShiftConfirmationMissed'),
            },
            {
              value: 'clockInConfirmationMissed',
              label: translate('automations.Automations.TriggerConditions.EventTypes.ClockInConfirmationMissed'),
            },
            {
              value: 'clockOutConfirmationMissed',
              label: translate('automations.Automations.TriggerConditions.EventTypes.ClockOutConfirmationMissed'),
            },
          ],
        },
      ],
    },
    {
      resourceType: 'CLIENT_MESSAGE',
      resourceTypeLabel: translate('automations.Automations.TriggerConditions.Resources.ClientMessage'),
      sentenceConnector: translate('automations.Automations.New.Steps.Rules.TriggerConditions.MessageInfix'),
      fields: [
        {
          key: 'messageType',
          label: translate('automations.Automations.TriggerConditions.Fields.MessageSource'),
          ruleType: 'STRING_EQUAL',
          isRequired: true,
          isVisibleToAdmin: true,
          options: [
            {
              value: 'EMAIL',
              label: translate('automations.Automations.TriggerConditions.MessageSources.Email'),
            },
            {
              value: 'SMS',
              label: translate('automations.Automations.TriggerConditions.MessageSources.Sms'),
            },
            {
              value: 'ANY',
              label: translate('automations.Automations.TriggerConditions.MessageSources.Any'),
            },
          ],
        },
        {
          key: 'body',
          label: translate('automations.Automations.New.Steps.Rules.AiEvaluatedRuleTitle'),
          ruleType: 'AI_PROMPT',
          isRequired: true,
          isVisibleToAdmin: true,
        },
        {
          key: 'sentBy',
          ruleType: 'STRING_EQUAL',
          isRequired: true,
          isVisibleToAdmin: false,
          options: [
            {
              value: 'USER',
            },
          ],
        },
      ],
    },
    {
      resourceType: 'CAREGIVER_MESSAGE',
      resourceTypeLabel: translate('automations.Automations.TriggerConditions.Resources.CaregiverMessage'),
      sentenceConnector: translate('automations.Automations.New.Steps.Rules.TriggerConditions.MessageInfix'),
      fields: [
        {
          key: 'messageType',
          label: translate('automations.Automations.TriggerConditions.Fields.MessageSource'),
          ruleType: 'STRING_EQUAL',
          isRequired: true,
          isVisibleToAdmin: true,
          options: [
            {
              value: 'EMAIL',
              label: translate('automations.Automations.TriggerConditions.MessageSources.Email'),
            },
            {
              value: 'SMS',
              label: translate('automations.Automations.TriggerConditions.MessageSources.Sms'),
            },
            {
              value: 'ANY',
              label: translate('automations.Automations.TriggerConditions.MessageSources.Any'),
            },
          ],
        },
        {
          key: 'body',
          label: translate('automations.Automations.New.Steps.Rules.AiEvaluatedRuleTitle'),
          ruleType: 'AI_PROMPT',
          isRequired: true,
          isVisibleToAdmin: true,
        },
        {
          key: 'sentBy',
          ruleType: 'STRING_EQUAL',
          isRequired: true,
          isVisibleToAdmin: false,
          options: [
            {
              value: 'USER',
            },
          ],
        },
      ],
    },
  ];
};

export default getAutomationRules;
